<template>
    <div class="container-div">
        <NavBarLight></NavBarLight><br><br>
        <div class="dashboard-content">
            <div class="row">
                <div id="header-image">
                    <h1 class="header-text">Take real world challenges to practice your skills</h1>
                </div>
                <div class="container" id="job-cards">
                    <div class="row">
                        <ChallengeCard v-for="(challenge, index) in orderedChallenges" :key="index" class="challenge-card" 
                            v-bind:title="challenge['.key']" 
                            v-bind:slug="challenge.Slug"
                            v-bind:challengeObj = "challenge"
                            v-bind:iconUrl="challenge.Icon"
                            v-bind:imgUrl="challenge.Background_image"
                            v-bind:supporting="challenge.Short_question"
                            v-bind:category="challenge.Category"
                            v-bind:status="challenge.Status"
                            v-bind:apply="challenge.Apply"
                            v-bind:ctaText="userStatus(challenge.Slug)"
                            v-bind:clickFunction="clickFunc">
                        </ChallengeCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBarLight from '@/components/NavBarLight.vue'
import ChallengeCard from '@/components/ChallengeCard.vue'
import firebase from '../services/firebase'

export default {
    name: 'PracticeDashboard',
    components: {
        NavBarLight,
        ChallengeCard
    },
    data: function() {
        return {
            challenges: []
        }
    },
    computed: {
        orderedChallenges: function() {
            return _.orderBy(this.challenges, 'Timestamp');
        }
    },
    firebase: {
         challenges: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true)
    },
    methods: {
         clickFunc: function(slug_sent, apply, challengeStatus) {
             console.log("slug sent is " + slug_sent);
             console.log("challenge is " + challengeStatus);

            if (firebase.auth().currentUser !== null) {
                mixpanel.track("clicked on challenge card", {
                    "challenge_name": slug_sent,
                    "user_id": firebase.auth().currentUser.uid,
                    "email": firebase.auth().currentUser.email
                });
            }

            if (apply !== true) {

                if (challengeStatus === "LIVE") {
                    this.$router.push('/dashboard/challenge/' + slug_sent);
                } else if (challengeStatus === "VOTING") {
                    this.$router.push('/dashboard/challenge/' + slug_sent + '/voting');
                } else if (challengeStatus === "ENDED") {
                    this.$router.push('/dashboard/challenge/' + slug_sent + '/results');
                }
            } else {
                this.$router.push('/dashboard/apply/' + slug_sent);
            }
            
         },
         userStatus: function(slug) {
            console.log("slug sent in userStatus is " + slug);
            if (this.fbLoaded) {
                if (this.userChallengeStatus[slug] === "Approved") {
                    console.log("user challenge status value is " + this.userChallengeStatus[slug]);
                    return "SUBMIT WORK";
                }

                else {
                    return "TAKE CHALLENGE";
                }
            }

            else {
                return "TAKE CHALLENGE";
            }
            
        }
    }
}
</script>


<style scoped>

    .container-div {
        font-family: Avenir;
    }

    .row {
        background-color: #f8faff;
    }

    .header-text {
        margin-top:30px;
        font-size: 1.5em;
        margin-bottom: 30px;
    }

    .challenge-card{
        width:28.7%;
    }

    @media (min-width: 768px) and (max-width: 992px) {
        .challenge-card {
            width: 45%;
        }
    }

    @media (min-width: 600px) and (max-width: 768px) {
        .challenge-card {
            width: 70%;
            margin: auto;
        }

    }

    @media (min-width: 430px) and (max-width:600px) {
        .challenge-card {
            width: 80%;
            margin: auto;
        }

    }

    @media (max-width:430px) {
        .challenge-card {
            width: 90%;
            margin:auto;
        }
    }

</style>